import { useActives } from '../../../../../hooks/useActives';
import { transformMaskCurrency } from '../../../../../utils/transformMaskCurrency';
import { IPropsTreasuryBondIR } from '../../@types';
import { Container } from './styles';

interface IPropsAssets {
  data: IPropsTreasuryBondIR;
}

export function AssetsAndRightsInformationTreasury({ data }: IPropsAssets) {
  //@ts-ignore
  const { showActive } = useActives();

  function formatValueForCurrency(value: number): string {
    return transformMaskCurrency(value);
  }

  return (
    <Container>
      <span>
        Discriminação:{' '}
        <strong>
          {showActive ? (
            <>
              {data.titulo} -
              QUANTIDADE: {data.saldo_final.quantidade}
            </>
          ) : (
            '*******************************************'
          )}
        </strong>
      </span>

      <span>
        Situação anterior:{' '}
        <strong>
          {showActive
            ? formatValueForCurrency(data.saldo_anterior.valor_aplicado)
            : 'R$ *****'}
        </strong>
      </span>
      <span>
        Situação atual:{' '}
        <strong>
          {showActive
            ? formatValueForCurrency(data.saldo_final.valor_aplicado)
            : 'R$ *****'}
        </strong>
      </span>
    </Container>
  );
}
